import React, { useState } from "react";
import CategoryList from "./CategoryList";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/common/PageHeader";
import SearchBar from "../../components/common/SearchBar";
import ShadowContainer from "../../components/common/ShadowContainer";

const CatSearch = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="h-screen flex flex-col bg-gradient-to-br from-gray-50 via-white to-gray-50 px-2 py-3 overflow-hidden">
      <div className="flex-shrink-0">
        <PageHeader
          showBackButton={true}
          backTo={-1}
          title="Category"
          subtitle={
            <span className="flex items-center gap-2">
              <span className="inline-block w-2 h-2 bg-blue-500 rounded-full"></span>
              Manage your categories and subcategories
            </span>
          }
          action={
            <button
              onClick={() => navigate("/add-category")}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4v16m8-8H4"
                />
              </svg>
              Create New Category
            </button>
          }
          search={
            <SearchBar
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search categories..."
              className="max-w-lg"
            />
          }
        />
      </div>

      {/* Scrollable Category Table */}
      <div className="flex-1 overflow-hidden">
        <ShadowContainer
          maxWidth="max-w-7xl"
          padding="p-0"
          className="h-full overflow-auto"
        >
          <CategoryList searchTerm={searchTerm} />
        </ShadowContainer>
      </div>
    </div>
  );
};

export default CatSearch;
